<template>
  <ul class="lang">
    <li v-for="(item, i) in languageList" :key="i" @click="setLang(item)">
      <div class="lang-item">
        <img class="lang-icon" :src="require(`@/assets/img/lang/${item.img}.png`)" alt="" />
        <span class="lang-text">{{ $ln(item.title) }}</span>
      </div>
    </li>
  </ul>
</template>

<script>
import { mixin as onClickOutside } from 'vue-on-click-outside'
import Base from '@/mixins/base'
import { mapLang } from '@/setting'

export default {
  name: 'langSelectList',
  mixins: [
    onClickOutside,
    Base
  ],
  data() {
    return {
      // 顯示語系選單
      // 'zh_hk' 取得url語系參數要顯示，但不顯示語系logo與選單
      showLang: ['zh_cn', 'en_us', 'vi_vn', 'th_th', 'id_id', 'ko_kr', 'ja_jp', 'pt_pt', 'es_es', 'bn_bd', 'hi_in', 'fr_fr'],
      languageList: []
    }
  },
  methods: {
    /**
     * 設定語系
     */
    setLang(item) {
      this.$emit('getLangSelected', item)
    },
    setLangList() {
      this.languageList = this.showLang.map((item) => {
        return mapLang[item]
      })
    }
  },
  created() {
    this.setLangList()
  }
}
</script>

<style scoped></style>
